import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n'; // Import i18n configuration
import './index.css';
import './styles/tokens.css';
import './styles/mobile.css';
import './styles/tablet.css';
import App from './App.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);